import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DropDownIdViewModel } from '../interfaces/dropDownIdViewModel'

interface InitialState {
    disableDoubleClick: boolean
    approvers: DropDownIdViewModel[]
}

const initialState: InitialState = {
    disableDoubleClick: false,
    approvers: []
}

const slice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setDisableDoubleClick: (state, action: PayloadAction<boolean>) => { state.disableDoubleClick = action.payload },
        setApprovers: (state, action: PayloadAction<DropDownIdViewModel[]>) => { state.approvers = action.payload }
    }
})

const { setDisableDoubleClick } = slice.actions

export { setDisableDoubleClick }

export default slice